import React from "react";
import { useParams } from "react-router-dom";
import Map from "./map";
export default function LinkMap({ earList }) {
  return <Map useParams={useParams()} earList={earList} />;
}
